export enum BannerType {
    FullWidth = 'fullWidth',
    Header = 'header',
    Footer = 'footer',
}
